import { DialogContextProps } from "@interfaces/System/DialogContextProps";
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { ModalContentLoading } from "@components/Common/Modal";
import React, { useRef } from "react";
import { staffBrandDealerBindService } from "@services/Staff";
import { useStoreon } from "storeon/react";
import { TableEvents, TableState } from "@store/table-module";
import { useSnackbar } from "notistack";
import { useAsync } from "@hooks";
import { CreateBrandDealerBindDto, UpdateBrandDealerBindDto } from "@dto/StaffOrderDto";
import { BrandDealerBindForm } from "@components/Forms/StaffOrder";

const BrandDealerBindDialogContext = ({ onClose, modalProps }: DialogContextProps) => {
    const { itemId } = modalProps;

    const formRef = useRef<HTMLFormElement>();
    const { enqueueSnackbar } = useSnackbar();
    const { dispatch: tableDispatch } = useStoreon<TableState, TableEvents>();

    const { data, loadingStatus } = useAsync(staffBrandDealerBindService.getOneBrandDealerBind, {
        functionArgs: [itemId],
        canLoad: !!itemId,
    });

    const invokeSubmit = () => {
        formRef.current!.handleSubmit();
    };

    const handleCreateBrandDealerBind = async (values) => {
        try {
            const dto = staffBrandDealerBindService.plainToClass(CreateBrandDealerBindDto, values);
            await staffBrandDealerBindService.createBrandDealerBind(dto);
            enqueueSnackbar("Предложение успешно создано", {
                variant: "success",
            });
            onClose();
            tableDispatch("table/update/data");
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при создании предложения", {
                variant: "error",
            });
        }
    };

    const handleUpdateBrandDealerBind = async (values) => {
        if (!data) return;

        try {
            const dto = staffBrandDealerBindService.plainToClass(UpdateBrandDealerBindDto, values);
            await staffBrandDealerBindService.updateBrandDealerBind(data.id, dto);
            enqueueSnackbar("Предложение успешно обновлено", {
                variant: "success",
            });
            onClose();
            tableDispatch("table/update/data");
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при обновлении предложения", {
                variant: "error",
            });
        }
    };

    return (
        <>
            <DialogContent>
                {loadingStatus === "loading" && <ModalContentLoading />}

                {(loadingStatus === "loaded" || loadingStatus === "inactivity") && (
                    <BrandDealerBindForm
                        ref={formRef}
                        data={data}
                        onSubmit={data ? handleUpdateBrandDealerBind : handleCreateBrandDealerBind}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onClose}>
                    Отмена
                </Button>
                <Button color="primary" variant="contained" onClick={invokeSubmit}>
                    Сохранить
                </Button>
            </DialogActions>
        </>
    );
};

export default BrandDealerBindDialogContext;
